module.exports = __webpack_public_path__ + "static/media/blue_circle.af3fdec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/blue_circle.png
// module id = 1126
// module chunks = 0